export {
  useSpinButton,
  type SpinButtonProps,
  type SpinbuttonAria
} from '../../../src/spinbutton/useSpinButton';
